import React from 'react'
import styled from '@emotion/styled';
// import core components
import { Overlay } from 'components';
import { queryHelper } from 'helpers';
import { toDisplayDate } from 'utils/moment';
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Wrapper = styled.div`
    position: relative;
    p {
        font-size: 14px;
    }
    img,
    h1,
    h2,
    h3 {
        margin: 0px;
        padding: 0px;
    }
    height: fit-content;
`;
const Header = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 15px;
`;
const Main = styled.div`
    padding: 10px;
    background-color: ${({theme}) => theme.colors.white};
    border: 3px solid ${({theme}) => theme.colors.stroke};
    border-radius: ${({theme}) => theme.borderRadius.default};
    box-sizing: border-box;
    box-shadow: ${({theme}) => theme.shadow.card};
    transition: ${({ theme }) => theme.transitions.cardHover};
    &.selected {
        border: 3px solid ${({theme}) => theme.colors.blue};
    }
    &.enabled:hover {
        transform: translateY(10px);
    }
    &.disabled {
        border: none;
    }
    cursor: pointer;
`;
const Title = styled.h1`
    font-weight: bold;
    font-size: 18px;
    line-height: 30px;
    color: ${props => props.theme.colors.blue};
    width: 80%;

    @media (max-width: ${props => props.theme.breakpoints.s}) {
        font-size: 18px;
        line-height: 28px;
    }
`;
const StyledImage = styled.div`
    width: 70px;
    max-height: 100%;
    right: 0px;
    top: 0px;
    border-radius: 50%;
    margin-right: 15px;
`;


const DealCard = props => {
    const { metaData, isDisabled, handleCheck, isSelected } = props;

    return (
        <Wrapper className={metaData.field_enabled ? "" : "hidden"}>
            {isDisabled && <Overlay />}
            <Main
                className={`${isSelected ? "selected" : ""} ${isDisabled ? "disabled" : "enabled"}`}
                onClick={ev => handleCheck(metaData)}
            >
                <Header>
                    <StyledImage>
                        <GatsbyImage 
                            style={{gridArea: "1/1"}}
                            layout="fullWidth"
                            aspectRatio={3 / 1}
                            image={getImage(queryHelper.getGatsbyImageData(metaData))} alt=""
                        />
                    </StyledImage>
                    <Title>{metaData.title}</Title>
                </Header>

                <p>{`${metaData.field_discount_limit ? 'Limited to ' + metaData.field_discount_limit + ' per customer' : 'Unlimited'}`}
                {` and expires on ${toDisplayDate(metaData.field_end_date)}`}</p>
                {/*`${toDisplayDate(metaData.field_start_date)} ~ ${toDisplayDate(metaData.field_end_date)}`*/}
                {/* {metaData.body.value && <p dangerouslySetInnerHTML={{ __html: metaData.body.value }} />} */}
            </Main>
        </Wrapper>
    )
};

export default DealCard;